import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { JobRequest } from 'types/JobTypes';
import { ClientProjectRequest, ProjectRequest, ProjectScopeRequest } from 'types/ProjectTypes';

export const PROJECT_MODAL = 'project';
export const CLIENT_MODAL = 'client';
export const SCOPE_MODAL = 'scope';
export const JOB_MODAL = 'job';
export const TASK_MODAL = 'task';

type ProjectModalMode = 'add' | 'edit';

type ProjectModalProps =
  | { type: typeof PROJECT_MODAL; data: ProjectRequest }
  | { type: typeof CLIENT_MODAL; data: ClientProjectRequest }
  | { type: typeof SCOPE_MODAL; data: ProjectScopeRequest }
  | { type: typeof JOB_MODAL; data: JobRequest }
  | { type: typeof TASK_MODAL; data: any };

interface ProjectModalState {
  open: boolean;
  mode: ProjectModalMode;
  /** The project being edited; null when adding. */
  modalProps: ProjectModalProps | null;
}

const initialState: ProjectModalState = {
  open: false,
  mode: 'add',
  modalProps: null,
};

const projectModalSlice = createSlice({
  name: 'projectModal',
  initialState,
  reducers: {
    openAddModal: (
      state,
      action: PayloadAction<{ type: ProjectModalProps['type']; data?: ProjectModalProps['data'] } | undefined>,
    ) => {
      state.open = true;
      state.mode = 'add';
      state.modalProps = action.payload
        ? ({ type: action.payload.type, data: action.payload.data ?? null } as ProjectModalProps)
        : null;
    },
    openEditModal: (state, action: PayloadAction<ProjectModalProps>) => {
      state.open = true;
      state.mode = 'edit';
      state.modalProps = action.payload;
    },
    closeModal: () => initialState,
  },
});

export const { actions: projectModalActions, reducer } = projectModalSlice;

export default projectModalSlice.reducer;
